import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The table's search box. It lives outside what gets replaced (so typing is never interrupted), which means it cannot carry the
// rest of the address in hidden fields: those would go stale after a sort or a filter. Instead it reads the current address when
// it searches, changes only q, and loads the table frame.
export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.sync = () => this.syncFromAddress()
    window.addEventListener("turbo:frame-load", this.sync)
  }

  disconnect() {
    clearTimeout(this.timer)
    window.removeEventListener("turbo:frame-load", this.sync)
  }

  debounce() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.search(), this.delayValue)
  }

  search() {
    const params = new URLSearchParams(window.location.search)
    const value = this.inputTarget.value.trim()
    if (value) params.set("q", value)
    else params.delete("q")
    params.delete("page")
    const query = params.toString()
    Turbo.visit(`${window.location.pathname}${query ? `?${query}` : ""}`, { frame: "ppc_table", action: "advance" })
  }

  // Something else changed the address (a filter was cleared, another range chosen): show what it now holds.
  syncFromAddress() {
    if (document.activeElement === this.inputTarget) return

    this.inputTarget.value = new URLSearchParams(window.location.search).get("q") || ""
  }
}
